import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import YoutubeEmbedVideo from "youtube-embed-video";
import pic11 from '../../assets/images/homeless-shelters.jpg'

const ShelterHomelessPost = (props) => (
    <div>
        <Helmet>
            <title>Homeless Support | Shelter | Help Charity</title>
            <meta name="description" content="ShelterHomelessPost Page" />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>Shelter for the homeless</h1>
                    </header>
                    <span className="image main"><img src={pic11} alt="" /></span>
                    <p><b>Life is tough for the homeless, however, thanks to an exciting new project, those who have no homes in Portsmouth can benefit from a shelter that will offer some respite from the winter.</b></p>
                    <p>Joanna Vines and Sammy Barcroft, two volunteers from the Rucksack Project, an initiative led by the community and which asks members of the public to donate rucksacks full of essentials to the homeless, are credited with coming with this latest solution to the nation’s homelessness crisis.</p>
                    
                    <hr/>
                    <h2>Crowdfunded project</h2>
                    <p>Back in 2016, Joanna received a suggestion that she should acquire a bus and turn it into a shelter for the homeless. A year later, in 2017, she managed to get her hands on a double decker from the well known bus company Stagecoach, which was due to be scrapped following 20 years of service on Britain’s roads. After gratefully accepting the bus, Joanna began the process of transformation – a process that took 8 months to reach completion and which cost about £6,000, a sum which was raised via crowdfunding and public donations.</p>

                    <h3>Help from the community</h3>
                    <p>Joanna, who lives in Fareham, parked the bus close to her home and then asked local people to come and help fit bunk beds and a kitchen. She received an overwhelming response, with 70-odd volunteers offering their services for the cause. One of Portsmouth’s colleges offered to make bunk beds for the project while one of the local housing association’s supplied a kitchen and plumbers and electricians from the area offered professional assistance.</p>
                    
                    <p>Today, the bus is parked outside Portsmouth’s St Agatha’s Church. It is currently a shelter for the homeless featuring 12 bunks, a kitchen and a living area and is set to be operated by one of the local churches under its Robert Dolling Project – a cause set up to support homeless people around Portsmouth.</p>

                    <hr/>

                    <YoutubeEmbedVideo videoId="NoPJebHagkw" 
                                       suggestions={false}
                                       width="100%"
                                       height="450px"  />
                    <br/>
                    <br/>
                    <h3>Homelessness A Nationwide Crisis</h3>
                    <p>According to Shelter, the UK’s leading homeless charity, over 300,000 people nationwide, a figure which equates to one out of every 200 people in the population, are recorded as being officially homeless or residing in inadequate accommodation for their needs. The freezing temperatures which we experience during the winter months as well as snow, rain and wind throughout the year, leave homeless people who have no warm place to stay in a potentially life-threatening situations, with a high risk of hypothermia and exposure.</p>

                    <hr/>
                    <h3>A rapid increase in homelessness</h3>
                    <p>Like most UK cities, and especially those in the south of the country, Portsmouth is struggling in the grip of a homelessness crisis. Recent statistics have shown that there are more people sleeping rough on the streets of the city than at any other time, and the problem looks only set to increase as housing remains unaffordable for many. This project, and others like it, give home to those who are living on the streets that they will be able to find a warm space to spend the night and eventually find a way to get back on their feet. Unfortunately, there is still a long way to go.</p>
                    <a href="/#header" className="button">BACK HOME</a>
                </div>
            </section>
        </div>

    </div>
)

export default ShelterHomelessPost


// WEBPACK FOOTER //
// ./src/pages/news/shelter-for-the-homeless.js